import type { ReactNode } from 'react';
import classnames from 'classnames';
import styles from './InlineReadElement.module.css';

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function InlineReadElement(props: { bold?: boolean; children: ReactNode; color?: 'muted' | 'primary' }) {
    let className = styles.inlineReadVariant;

    if (props.bold) {
        className += ` ${styles.bold}`;
    }

    if (props.color) {
        className += props.color === 'muted' ? ` ${styles.muted}` : ` ${styles.primary}`;
    }

    return <span className={classnames(className)}>{props.children}</span>;
}
